import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { RouteLoadDurationProvider } from '@awsscm/argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';
import Receive from './containers/Receive';
import ContainerManagement from './containers/ContainerManagement';
import ContainerMove from './containers/InventoryMove/ContainerMove';
import InventoryMove from './containers/InventoryMove';
import PartsMove from './containers/PartsMove';

const Home = React.lazy(() => import('./containers/Home'));
const CycleCount = React.lazy(() => import('./containers/CycleCount'));
const AssetValidation = React.lazy(() => import('./containers/AssetValidation'));

export default function Routes(): React.ReactElement {
  return (
    <RouteLoadDurationProvider>
      <React.Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/cycle-count" component={CycleCount} />
          <Route path="/receive" component={Receive} />
          <Route path="/asset-validation" component={AssetValidation} />
          <Route path="/container/manage" component={ContainerManagement} />
          <Route path="/container" component={ContainerManagement} />
          <Route path="/move/container" component={ContainerMove} />
          <Route path="/move" component={InventoryMove} />
          <Route path="/parts-move" component={PartsMove} />
        </Switch>
      </React.Suspense>
    </RouteLoadDurationProvider>
  );
}
